import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import PaymentGatewaySelector from '../components/PaymentGatewaySelector';

const TestTicketBooking = () => {
  const [parks, setParks] = useState([]);
  const [selectedPark, setSelectedPark] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [customerInfo, setCustomerInfo] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const [booking, setBooking] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState(null);

  useEffect(() => {
    fetchParks();
  }, []);

  const fetchParks = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/public/tickets`);
      setParks(response.data.tickets || []);
    } catch (error) {
      console.error('Error fetching parks:', error);
    }
  };

  const createBooking = async (e) => {
    e.preventDefault();
    try {
      if (!selectedGateway) {
        alert('Please select a payment gateway');
        return;
      }

      const bookingData = {
        ticketTypeId: selectedPark._id,
        quantity,
        customerName: customerInfo.name,
        customerEmail: customerInfo.email,
        customerPhone: customerInfo.phone,
        totalAmount: selectedPark.price * quantity,
        gatewayId: selectedGateway._id
      };

      const response = await axios.post(`${API_BASE_URL}/api/test-bookings/create`, bookingData);
      
      if (response.data.success) {
        setBooking(response.data.booking);
        console.log('Booking created:', response.data.booking);
        console.log('Payment URL:', response.data.paymentUrl);
        
        if (response.data.paymentUrl) {
          console.log('Opening payment URL:', response.data.paymentUrl);
          // Store payment URL for manual access
          sessionStorage.setItem('lastPaymentUrl', response.data.paymentUrl);
          
          // Try to open payment URL
          const paymentWindow = window.open(response.data.paymentUrl, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
          if (!paymentWindow || paymentWindow.closed || typeof paymentWindow.closed == 'undefined') {
            // Popup blocked - show URL for manual opening
            const userConfirm = window.confirm('Popup blocked! Click OK to open payment page manually.');
            if (userConfirm) {
              window.location.href = response.data.paymentUrl;
              return;
            }
          }
          setShowPayment(true);
        } else {
          alert('Payment URL not generated. Check console for errors.');
          setShowPayment(true);
        }
      }
    } catch (error) {
      alert('Booking creation failed: ' + (error.response?.data?.message || error.message));
    }
  };



  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Test Ticket Booking</h1>
          <p className="text-gray-600">ICICI UAT Integration Test</p>
        </div>

        {!showPayment ? (
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-bold mb-6">Book Your Ticket</h2>
            
            <form onSubmit={createBooking}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Select Park</label>
                  <select
                    value={selectedPark?._id || ''}
                    onChange={(e) => setSelectedPark(parks.find(p => p._id === e.target.value))}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Choose a park...</option>
                    {parks.map(park => (
                      <option key={park._id} value={park._id}>
                        {park.name} - ₹{park.price}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Quantity</label>
                  <input
                    type="number"
                    min="1"
                    max="10"
                    value={quantity}
                    onChange={(e) => setQuantity(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <input
                  type="text"
                  placeholder="Full Name"
                  value={customerInfo.name}
                  onChange={(e) => setCustomerInfo({...customerInfo, name: e.target.value})}
                  required
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={customerInfo.email}
                  onChange={(e) => setCustomerInfo({...customerInfo, email: e.target.value})}
                  required
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="tel"
                  placeholder="Phone"
                  value={customerInfo.phone}
                  onChange={(e) => setCustomerInfo({...customerInfo, phone: e.target.value})}
                  required
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {selectedPark && (
                <div className="bg-blue-50 p-4 rounded-lg mb-6">
                  <h3 className="font-semibold text-blue-900">Booking Summary</h3>
                  <p className="text-blue-800">Park: {selectedPark.name}</p>
                  <p className="text-blue-800">Quantity: {quantity} tickets</p>
                  <p className="text-blue-800 font-bold">Total: ₹{selectedPark.price * quantity}</p>
                </div>
              )}

              <div className="mb-6">
                <h3 className="text-lg font-semibold mb-4">Select Payment Gateway</h3>
                <PaymentGatewaySelector 
                  onSelect={setSelectedGateway}
                  selectedGateway={selectedGateway}
                />
              </div>

              <button
                type="submit"
                disabled={!selectedPark || !selectedGateway}
                className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white py-3 rounded-lg font-medium transition-colors"
              >
                Create Booking & Pay
              </button>
            </form>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-bold mb-6">Payment Processing</h2>
            <div className="text-center py-8">
              <div className="text-4xl mb-4">⏳</div>
              <h3 className="text-lg font-semibold mb-2">Payment window opened</h3>
              <p className="text-gray-600 mb-4">Complete your payment in the new window</p>
              
              {booking && (
                <div className="space-y-3">
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                    <p className="text-sm text-yellow-800">If payment window didn't open:</p>
                    <button
                      onClick={() => {
                        // Get the payment URL from the last response
                        const lastPaymentUrl = sessionStorage.getItem('lastPaymentUrl');
                        if (lastPaymentUrl) {
                          window.open(lastPaymentUrl, '_blank');
                        }
                      }}
                      className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg mt-2"
                    >
                      Open Payment Page Manually
                    </button>
                  </div>
                  
                  <button
                    onClick={() => window.location.href = `/test-booking-status/${booking._id}`}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg"
                  >
                    Check Booking Status
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestTicketBooking;